import { createWebHistory, createRouter } from 'vue-router'
import Home from '@/Page/Main.vue'
import Project from '@/Page/Project.vue'
import ProjectDetail from '@/Page/Project.Detail.vue'
import About from '@/Page/About.vue'

const routes = [
  {
    path: '/portfolio/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/portfolio/project',
    name: 'Project',
    component: Project,
  },
  {
    path: '/portfolio/project/:title',
    name: 'ProjectDetail',
    component: ProjectDetail,
  },
  {
    path: '/portfolio/about',
    name: 'About',
    component: About,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }

});

export default router;
